<template>
  <div class="listPage overflow-hidden">
    <MessageList v-if="tabName === 2 || tabName === 3 || tabName === 4" 
      ref="messageList"
      :tabName="tabName" 
      :entitiesType="typeSelected">
    </MessageList>
  </div>
</template>

<script>

import MessageList from "@/pages/routing/MessageList.vue";

export default {
  name: 'EntitiesSettings',
  components: {
    MessageList
  },
  props: {
    type: {
      default: "rvm"
    },
    role: {
      default: "0"
    },
    ConfigurationType: {
      default: "MQSERIES"
    },
  },
  computed: {
  },
  data () {
    return {
      tabName: 0,
      tabIndex: 0,
      typeSelected: 'rvm'
    }
  },
  created () {
    if (this.type == 'responder'){
      this.tabName = 1
    }
    if (this.ConfigurationType == 'Corporate'){
      this.tabName = 3
      this.typeSelected = "requester"
    }
    if (this.ConfigurationType == 'SI'){
      this.tabName = 4
      this.typeSelected = "responder"
    }
    if (this.ConfigurationType == 'BICRVM'){
      this.tabName = 2
      this.typeSelected = "rvm"
    }
    this.typeSelected = this.type
    if (this.type == 'rvmconfig'){
      this.tabName = 1
      this.typeSelected = "rvm"
    }
    if (this.type == 'rvmcredential'){
      this.tabName = 0
      this.typeSelected = "rvm"
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

